import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter, withDisabledInitialNavigation } from '@angular/router';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideNoopAnimations } from '@angular/platform-browser/animations';
import { NgxSpinnerModule } from 'ngx-spinner';
import { InteractionType, BrowserUtils } from '@azure/msal-browser';
import { MsalGuard, MsalBroadcastService, MsalModule, MsalService, MSAL_GUARD_CONFIG, MSAL_INSTANCE } from '@azure/msal-angular';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { SharedModule } from 'src/app/shared/shared.module';
import { CAPABILITIES_PROVIDERS } from './modules/capabilities/capabilities.providers';
import { HttpConfigInterceptor } from './core/interceptors/httpconfig.interceptor';
import { HttpErrorInterceptor } from './core/interceptors/http-error.interceptor';
import { APP_ROUTES } from './app.routes';
import { MSALInstanceFactory, MSALGuardConfigFactory } from './msal.factories';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(
      APP_ROUTES,
      ...(!BrowserUtils.isInIframe() && !BrowserUtils.isInPopup() ? [] : [withDisabledInitialNavigation()]),
    ),
    provideHttpClient(withInterceptorsFromDi()),
    provideCharts(withDefaultRegisterables()),
    provideNoopAnimations(),
    ...CAPABILITIES_PROVIDERS,
    importProvidersFrom(
      SharedModule,
      NgxSpinnerModule,
      MsalModule.forRoot(MSALInstanceFactory(), MSALGuardConfigFactory(), {
        interactionType: InteractionType.Redirect,
        protectedResourceMap: new Map(),
      }),
    ),
    {
      // Registrado antes que `HttpConfigInterceptor`: así solo dispara sobre el
      // error final, después de que su retry/refresh de 401 ya haya corrido.
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpConfigInterceptor,
      multi: true,
    },
    { provide: MSAL_INSTANCE, useFactory: MSALInstanceFactory },
    { provide: MSAL_GUARD_CONFIG, useFactory: MSALGuardConfigFactory },
    { provide: 'LOCALE_ID', useValue: 'es-ES' },
    { provide: MAT_DATE_LOCALE, useValue: 'es-ES' },
    MsalService,
    MsalGuard,
    MsalBroadcastService,
  ],
};
